import './index.css';
import ServicesSubMenu from '../ServicesSubMenu';

const appServices = [
  {
    title: 'Simple Mobile Presence',
    description:
      'Start with a clean, focused mobile app that gives customers a direct way to find your business, understand your services, and take the next step.',
  },
  {
    title: 'Customer Logins',
    description:
      'Let clients log in to become part of your network, review previous orders, update contact details, and manage their profile directly inside the app.',
  },
  {
    title: 'Two-Way Messaging',
    description:
      'Add SMS messaging, customer conversations, notifications, status updates, and business workflows that keep communication organized inside the app experience.',
  },
  {
    title: 'Scheduling',
    description:
      'Help customers request appointments, manage scheduling communication, and stay connected with reminders or follow-up messages from the app.',
  },
  {
    title: 'Ordering and Service Requests',
    description:
      'Build ordering, booking, intake, scheduling, and request flows that connect mobile users to the systems and people who fulfill the work.',
  },
  {
    title: 'Cloud-Powered Growth',
    description:
      'Design apps with the cloud infrastructure behind them, so the application can grow from a simple first release into a more capable business platform.',
  },
];

const ServicesAppDev = () => {
  return (
    <div className="services-placeholder-page">
      <ServicesSubMenu />
      <section className="services-placeholder-hero">
        <p className="services-placeholder-kicker">Hogcloud Services</p>
        <h1>App Development</h1>
        <p>
          Custom mobile app development for businesses that want to expand
          beyond the web and into the mobile application landscape. Start small,
          launch something useful, and add features as your needs grow.
        </p>
      </section>

      <section className="appdev-overview" aria-labelledby="appdev-overview-title">
        <div className="appdev-overview-copy">
          <p className="services-placeholder-kicker">Mobile Apps</p>
          <h2 id="appdev-overview-title">From simple presence to connected services</h2>
          <p>
            Hogcloud builds custom mobile apps ranging from a simple business
            presence to complex SMS messaging, scheduling, ordering, booking,
            and customer service tools.
          </p>
          <p>
            We understand how to develop mobile apps that scale because we have
            deep experience with the cloud infrastructure that powers the
            application. That means your first app can be practical and
            affordable without closing the door on future growth.
          </p>
        </div>

        <aside className="appdev-price-callout" aria-label="Starting price">
          <span>Starting at</span>
          <strong>$500</strong>
          <p>Launch a simple mobile app and add features as you need them.</p>
        </aside>
      </section>

      <section className="appdev-services" aria-label="App development services">
        {appServices.map((service) => (
          <article className="appdev-service-card" key={service.title}>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </article>
        ))}
      </section>

      <section className="appdev-footnote" aria-labelledby="app-store-registration-note-title">
        <h2 id="app-store-registration-note-title">Mobile App Registration Process</h2>
        <p>
          Mobile app development includes registration with the Apple App Store
          and Google Play. Both require separate company registrations:
          Apple Developer Program membership is $99 per year, and Google Play
          developer registration is a $25 one-time fee. Hogcloud manages the
          entire process and makes it easy to ensure your company app is
          registered properly. 
        </p>
        <p>
          <strong>Time to Delivery </strong> - Typical approval time and deployment to the app stores can be turned out in less than 2 weeks.  
        </p>
      </section>
    </div>
  );
};

export default ServicesAppDev;
